export const setToken = token => {
	localStorage.setItem('token', token);
};
export const getToken = () => {
	return localStorage.getItem('token');
};
export const removeToken = () => {
	return localStorage.removeItem('token');
};

export const checkFileSize = (file, max = 256) => {
	if (file) {
		const size = file.size / 1024 / 1024;
		if (size > max) {
			return false;
		}
	}
	return true;
};

function getExtension(filename) {
	var parts = filename?.split('.');
	if (parts) {
		return parts[parts.length - 1];
	}
}

export const isImage = filename => {
	const ext = getExtension(filename);
	if (ext) {
		switch (ext.toLowerCase()) {
			case 'jpg':
			case 'jpeg':
			case 'webp':
			case 'gif':
			case 'bmp':
			case 'png':
				return true;
			default:
				return false;
		}
	}

	return false;
};

export const isVideo = filename => {
	const ext = getExtension(filename);
	if (ext) {
		switch (ext.toLowerCase()) {
			case 'm4v':
			case 'avi':
			case 'mpg':
			case 'mp4':
			case 'mov':
			case 'qt':
			case 'webm':
				// etc
				return true;
			default:
				return false;
		}
	}

	return false;
};

export const getFormat = fileName => {
	return isVideo(fileName) ? 'video' : 'photo';
}


export const getLaravelValidationErrors = errors => {
	return typeof errors === 'object' && errors.hasOwnProperty('errors')
		? Object.entries(errors.errors)
		: ['Server error!'];
};

export const handleDecimalDots = (stringValue, charValue) => {
	return stringValue.indexOf(charValue) > -1;
};

